import request from '../services/request';

export const getContentFeed = page => request.get('/feed', { params: { page } });
export const getFeaturedContentFeed = (page = null, perPage = null) => request.get('/feed/featured', { params: { page, perPage } });
export const searchContent = (q, page) => request.get('/search', { params: { q, page } });
